// removed by extract-text-webpack-plugin
module.exports = {"noTopMargin":"_3KeqZhHo8ze03ztuPbji-O","mr20":"v_8rqrHGtsCj2SeBcFxoV","itemsStart":"_2IiJrZFEYjPLZa9fhPfdFk","pr150":"_1HNxxqCdB3U4I_hGrR8Xn3","resetBtn":"_1W8BYydx_VQHxz0l7d05lx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/ApplicationReview/style.scss
// module id = 554
// module chunks = 1